import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 20px;
  width: 100%;
  position: relative;
`

export const Form = styled.form`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
  padding-top: 16px;
`
